import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import ScheduleContainer from "../../Container/MainContainer/ScheduleContainer";
import ScheduleTotalContainer from "../../Container/MainContainer/ScheduleTotalContainer";

function ScheduleRouter({ match, location, history }: RouteComponentProps) {
  return (
    <Switch>
      {/* <Route
        path={`/archive/:sub_page_slug`}
        render={({ match, history, location }: RouteComponentProps) => {
          console.log(match);
          return <div>보드 페이지</div>;
        }}
      /> */}
      {/* <Route
        exact
        path={"/schedule/"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <ScheduleContainer match={match} history={history} />;
        }}
      /> */}

      <Route
        exact
        path={"/schedule"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <ScheduleTotalContainer match={match} history={history} />;
        }}
      />
      <Route
        exact
        path={"/schedule/month/"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <ScheduleContainer match={match} history={history} />;
        }}
      />

      <Route
        exact
        path={"/schedule/month/:param_month"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <ScheduleContainer match={match} history={history} />;
        }}
      />

      <Route
        path={"/schedule/:page_id"}
        component={({ match, location, history }: RouteComponentProps) => {
          return <ScheduleTotalContainer match={match} history={history} />;
        }}
      />
    </Switch>
  );
}
export default ScheduleRouter;
